import { useState, useEffect, useRef } from 'react'
import { getUnits } from 'store/actions/unitActions'

const useGetUnits = (id = '') => {
  const mountedRef = useRef(true)
  const [units, setUnits] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getData(id)
    return () => {
      mountedRef.current = false
    }
  }, [])

  const getData = async (id = '') => {
    setLoading(true)
    try {
      const data = await getUnits(id || '')
      if (!mountedRef.current) return null
      setUnits(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  return { loading, units, refetch: () => getData(id) }
}

export default useGetUnits
